import {
  BottomNavigation,
  BottomNavigationAction,
  useTheme,
} from '@mui/material'
import { useEffect, useState } from 'react'

import { useCurrentArtistState } from '@/clients/utoniq-core'
import { config } from '@/config'
import { useRouter } from '@/core'
import { getArtistAppLink } from '@/lib/url'
import { ArtistTabKeys } from '@/types/tabs'

import { useTabList } from './TabList'

export const ArtistBottomNavigation = ({
  tabKeys,
  isLive,
  hasManagementTask,
  defaultTab = null,
  unreadNotificationCount,
}: Props) => {
  const { router } = useRouter<{ artistId: string }>()
  const [currentTab, setCurrentTab] = useState(defaultTab)
  const artist = useCurrentArtistState()
  const artistAppLink = getArtistAppLink(
    artist?.appLinks,
    'bottomTab:profile'
  )?.link

  const theme = useTheme()

  /**
   * @description
   * Open when function is implemented in the future
   * https://app.clickup.com/t/908127/UT-6887
   */
  const tabs = useTabList({
    avatarUri: artist?.avatar?.smallUri || undefined,
    appLink: artistAppLink,
    isLive,
    hasManagementTask,
    unreadNotificationCount,
    totalUnreadMentionCount: artist?.totalUnreadMentionCount ?? 0,
  })

  useEffect(() => {
    /**
     * /artists/:artistId/:tabKeyのURLからtabKeyの値をvセットする
     * /:tabKeyのURLからtabKeyの値をvセットする
     */
    const index = config.applicationType === 'standalone' ? 0 : 2
    const path = router.pathname.split('/').filter(Boolean)[index]
    setCurrentTab(path)
  }, [router.pathname])

  const filteredTabKeys = tabKeys.filter(tab => {
    if (tab !== 'artistProfile') return true
    return !!artistAppLink
  })

  return (
    <BottomNavigation
      id="artist-bottom-navigation"
      className="artist-bottom-navigation"
      value={currentTab}
      showLabels
      sx={{ bgcolor: 'grey.50' }}
    >
      {filteredTabKeys.map(key => (
        <BottomNavigationAction
          {...tabs[key]}
          key={key}
          sx={{
            opacity: key === 'home' && currentTab !== 'home' ? 0.4 : 1,
            maxWidth: 600 / filteredTabKeys.length,
            '.MuiBottomNavigationAction-label': {
              // fontFamily:
              //   theme.mixins.artistNavigation?.fontFamily ?? undefined,
              color: tabs[key].color ?? undefined,
            },
            '&.Mui-selected .MuiBottomNavigationAction-label': {
              // fontFamily:
              //   theme.mixins.artistNavigation?.fontFamily ?? undefined,
              color: tabs[key].color ?? undefined,
            },
          }}
        />
      ))}
    </BottomNavigation>
  )
}

type Props = {
  tabKeys: ArtistTabKeys[number][]
  /**
   * Initial display tab.If not set, the first tab can be displayed.
   */
  defaultTab?: string | null
  /**
   * ライブ配信を行なっているか
   */
  isLive: boolean
  /**
   * 配送申請・コンビニ決済が必要である場合true
   */
  hasManagementTask: boolean
  /**
   * 未読の通知数
   */
  unreadNotificationCount?: number
}
